export default "__VITE_ASSET__1tB1l9xL__"